const newsletterData = {
  heading: 'Subscribe to our newsletter',
  sub: 'Stay up to date with our offer.',
  accept: 'I accept the ',
  privacyPolicy: 'privacy policy.',
  PPLink: '/privacy-policy',
  inputPlaceholder: 'your e-mail address',
  buttonValue: 'subscribe',
  sending: 'Sending...',
  success: 'Thank you for subscribing!',
  error: 'An unexpected internal error has occurred.',
  empty: 'You must write an e-mail.',
  duplicate: 'Too many subscribe attempts for this email address'
};

export { newsletterData };